import { render, staticRenderFns } from "./DormitoryManage.vue?vue&type=template&id=388386dc&scoped=true"
import script from "./DormitoryManage.vue?vue&type=script&lang=js"
export * from "./DormitoryManage.vue?vue&type=script&lang=js"
import style0 from "./DormitoryManage.vue?vue&type=style&index=0&id=388386dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388386dc",
  null
  
)

export default component.exports